(function () {
  const ENGRAVING_VARIANT_ID = 47886189986017;

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[is="product-form"], form[data-type="add-to-cart-form"]')) return;

      const checkbox = form.querySelector('[id^="engraving_addon_"]');
      const input = form.querySelector('[id^="engraving_text_"]');

      if (!checkbox || !input) return;
      if (!checkbox.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const engravingText = (input.value || '').trim();
      if (!engravingText) {
        alert('Skriv inn graveringstekst.');
        return;
      }

      const qtyInput = form.querySelector('input[name="quantity"]');
      const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('btn--loading');
      }

      try {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        // 1) hovedprodukt
        const config1 = FoxTheme.utils.fetchConfig('javascript');
        config1.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config1.headers['Content-Type'];

        const fd1 = new FormData(form);
        fd1.append('properties[Gravering]', 'Ja');
        fd1.append('properties[Graveringstekst]', engravingText);
        fd1.append('sections', sectionsToBundle);
        fd1.append('sections_url', window.location.pathname);

        config1.body = fd1;

        const res1 = await fetch(`${FoxTheme.routes.cart_add_url}`, config1);
        const parsed1 = await res1.json();
        if (parsed1.status) {
          alert(parsed1.description || 'Kunne ikke legge i handlekurv.');
          return;
        }

        // 2) gravering-tillegg
        const config2 = FoxTheme.utils.fetchConfig('javascript');
        config2.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config2.headers['Content-Type'];

        const fd2 = new FormData();
        fd2.append('id', String(ENGRAVING_VARIANT_ID));
        fd2.append('quantity', String(quantity));
        fd2.append('properties[Gravering]', 'Ja');
        fd2.append('properties[Graveringstekst]', engravingText);
        fd2.append('sections', sectionsToBundle);
        fd2.append('sections_url', window.location.pathname);

        config2.body = fd2;

        const res2 = await fetch(`${FoxTheme.routes.cart_add_url}`, config2);
        const parsed2 = await res2.json();
        if (parsed2.status) {
          alert(parsed2.description || 'Kunne ikke legge til gravering.');
          return;
        }

        const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
        cartJson['sections'] = parsed2['sections'];

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: { product: parsed2 },
          })
        );

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && FoxTheme.settings.cartType !== 'page') {
          cartDrawer.show(submitBtn || form);
        } else {
          window.location.href = FoxTheme.routes.cart_url;
        }
      } catch (e) {
        console.error(e);
        alert('Noe gikk galt. Prøv igjen.');
      } finally {
        if (submitBtn) {
          submitBtn.classList.remove('btn--loading');
          submitBtn.removeAttribute('aria-disabled');
        }
      }
    },
    true
  );
})();